import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiPieChart = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
export {
  MuiPieChart
};
//# sourceMappingURL=MuiPieChart.js.map
